/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import NumberFormat from 'react-number-format';
import css from '../styles/contact-us.scss';
import { isMobile } from 'react-device-detect';

class FeedbackFormInputComponent extends Component {
    static propTypes = {
      label: PropTypes.string.isRequired,
      type: PropTypes.oneOf(['SHORT', 'LONG', 'EMAIL', 'PHONE']).isRequired,
      name: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
      placeholder: PropTypes.string.isRequired,
      onChange: PropTypes.func.isRequired,
      checkError: PropTypes.func.isRequired,
      error: PropTypes.string.isRequired,
    }

    constructor(props) {
      super(props);
      this.state = {
        active: false,
        value: props.value,
        touched: false,
        showError: false,
      };
    }

    onChangeCalls = (e) => {
      const { onChange, name } = this.props;
      const { touched } = this.state;
      onChange(name, e);
      this.setState({
        value: e.target.value,
        showError: this.validate(e.target.value) && touched,
      });
    };

    onBlur = (e) => {
      this.setState({
        touched: true,
        active: false,
        showError: this.validate(e.target.value),
      });
    }

    onFocus = () => {
      this.setState({ active: true });
    }

    setError = (name, value) => {
      switch (name) {
        case 'phone':
          return value.split(' ').length - 1 > 1;
        case 'email':
          return !(this.validEmail(value) || value === '');
        case 'message':
          return value === '';
        default:
          return false;
      }
    }

    validEmail = (email) => {
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{3,}))$/;
      return re.test(email);
    }

    validate = (value) => {
      const { name, checkError } = this.props;
      const isError = this.setError(name, value);

      checkError(name, !isError);
      return isError;
    }

    render() {
      const {
        label, type, name, placeholder, error,
      } = this.props;
      const {
        active, value, showError,
      } = this.state;
      const types = {
        SHORT: 'text',
        LONG: 'text',
        EMAIL: 'email',
        PHONE: 'tel',
      };

      const hrClass = classNames({
        [css.activeLine]: active && !showError,
        [css.inactiveLine]: !active && !showError,
        [css.errorLine]: showError,
      });

      const labelClass = classNames({
        [css.activeLabel]: active && !showError,
        [css.errorLabel]: showError,
      });

      const mobileLabelClass = classNames({
        [css.mobileLabel]: !active && !showError,
        [css.mobileActiveLabel]: active && !showError,
        [css.mobileErrorLabel]: showError,
      })

      if(!isMobile){
        return (
          <div
            className={type === 'LONG' ? css.inputWrapper : css.shortInputWrapper}
          >
            <label htmlFor={name} className={labelClass}>
              {label}
            </label>
            {type === 'PHONE'
              ? (
                <NumberFormat
                  className={css.inputField}
                  format="(###) ###-####"
                  mask=" "
                  type={types[type]}
                  placeholder={placeholder}
                  value={value}
                  onChange={this.onChangeCalls}
                  onBlur={this.onBlur}
                  onFocus={this.onFocus}
                />
              )
              : (
                <input
                  className={css.inputField}
                  name={name}
                  type={types[type]}
                  placeholder={placeholder}
                  value={value}
                  onChange={this.onChangeCalls}
                  onBlur={this.onBlur}
                  onFocus={this.onFocus}
                />
              )
            }

            <hr className={hrClass} />
            {showError && <p className={css.errorText}>{error}</p> }
          </div>
        );
      }
      else{
        return (
          <div className={css.mobileInputWrapper}>
            <div className={mobileLabelClass}>
              {label}
            </div>
            {type === 'PHONE'
              ? (
                <NumberFormat
                  className={css.mobileInputField}
                  format="(###) ###-####"
                  mask=" "
                  type={types[type]}
                  placeholder={placeholder}
                  value={value}
                  onChange={this.onChangeCalls}
                  onBlur={this.onBlur}
                  onFocus={this.onFocus}
                />
              )
              : (
                <input
                  className={css.mobileInputField}
                  name={name}
                  type={types[type]}
                  placeholder={placeholder}
                  value={value}
                  onChange={this.onChangeCalls}
                  onBlur={this.onBlur}
                  onFocus={this.onFocus}
                />
              )
            }

            <hr className={hrClass} />
            {showError && <p className={css.mobileErrorText}>{error}</p> }
          </div>
        );
      }
    }
}

export default FeedbackFormInputComponent;
